import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { inputMessageKeyframe } from "styles";
import { useField } from "formik";
import NumberFormat from "react-number-format";

// assets
import DangerIcon from "assets/icons/danger-icon.svg";
import SuccessIcon from "assets/icons/success-icon.svg";

const NumberInput = ({
  inputType,
  label,
  thousandSeparator,
  successMsg,
  marginBottom,
  ...props
}) => {
  const [field, meta, helpers] = useField(props);
  const { value, setValue } = helpers;

  return (
    <Wrapper marginBottom={marginBottom}>
      {label && <Label htmlFor={field.name}>{label}</Label>}
      {inputType === "basic" ? (
        <StyledNumberInput
          isNumericString={true}
          thousandSeparator={thousandSeparator}
          value={value}
          onValueChange={(val) => setValue(val.floatValue)}
          {...field}
          {...props}
        />
      ) : (
        <StyledNumberInput
          isNumericString={false}
          value={value}
          onValueChange={(val) => setValue(val.floatValue)}
          format="###-####-####"
          mask=""
          allowEmptyFormatting={false}
          {...field}
          {...props}
        />
      )}

      {meta.error && meta.touched ? (
        <Message className="error">
          <img src={DangerIcon} />
          {meta.error}
        </Message>
      ) : null}
      {!meta.error && meta.touched && successMsg ? (
        <Message className="success">
          <img src={SuccessIcon} />
          {successMsg}
        </Message>
      ) : null}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${(props) =>
    props.marginBottom ? props.marginBottom : "16px"};
`;

const Label = styled.label`
  display: block;
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  color: ${(props) => props.theme.colors.inputLabel};
  margin-bottom: 8px;
  line-height: 20px;
`;

const StyledNumberInput = styled(NumberFormat)`
  height: 48px;
  width: 100%;
  padding: 14px 16px;
  border: 1px solid ${(props) => props.theme.colors.inputBorder};
  border-radius: 6px;
  font-size: 16px;
  :focus {
    outline: none;
    border-color: ${(props) => props.theme.colors.inputActive};
  }
`;

const Message = styled.div`
  font-size: 12px;
  margin-top: 6px;
  animation: ${inputMessageKeyframe} 0.5s;

  &.error {
    color: #da2e2e;
  }

  &.success {
    color: #004fec;
  }

  display: flex;
  flex-direction: row;
  align-items: center;

  img {
    margin-right: 6px;
  }
`;

NumberInput.propTypes = {
  inputType: PropTypes.oneOf(["basic", "phone"]).isRequired,
  label: PropTypes.string,
  successMsg: PropTypes.string,
  thousandSeparator: PropTypes.bool,
};

NumberInput.defaultProps = {
  inputType: null,
  label: null,
  successMsg: null,
  thousandSeparator: false,
};

export default NumberInput;
